import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";

import DashboardLayout from "./components/DashboardLayout";
import DetalleAprendiz from "./components/DetalleAprendiz";
import PrivateRoute from "./components/PrivateRoute";

import AsignacionModulos from "./view/AsignacionModulos";
import Home from "./view/Home";
import ListarActas from "./view/ListarActas";
import ListarActividad from "./view/ListarActividad";
import ListarAgendasViaticos from "./view/ListarAgendasViaticos";
import ListarAprendices from "./view/ListarAprendices";
import ListarCentros from "./view/ListarCentros";
import ListarContratos from "./view/ListarContratos";
import ListarEnte from "./view/ListarEnteconformador";
import ListarEnteVsJefe from "./view/ListarEnteVsJefe";
import ListarEProductiva from "./view/ListarEProductiva";
import ListarGrupos from "./view/ListarGrupos";
import ListarGrupoInstructores from "./view/ListarGrupoInstructores";
import ListarGuias from "./view/ListarGuiasdeAprendizaje";
import ListarInformesContractuales from "./view/ListarInformesContractuales";
import ListarInstructores from "./view/ListarInstructores";
import ListarJefes from "./view/ListarJefes";
import ListarMatriculados from "./view/ListarMatriculados";
import ListarMatriculas from "./view/ListarMatriculas";
import ListarObligaciones from "./view/ListarObligaciones";
import ListarProgramas from "./view/ListarProgramas";
import ListarRegionales from "./view/ListarRegionales";
import ListarResoluciones from "./view/ListarResoluciones";
import ListarTarjetaAprendiz from "./view/ListarTarjetasAsignadas";
import Login from "./view/Login";
import MiPerfil from "./view/MiPerfil";
import MiPerfilEditar from "./view/MiPerfilEditar";
import Notificaciones from "./view/Notificaciones";
import RegistrarActas from "./view/RegistrarActas";
import RegistrarActividad from "./view/RegistrarActividad";
import RegistrarAgendasViaticos from "./view/RegistrarAgendasViatiocos";
import RegistrarAsistencia from "./view/RegistrarAsistencia";
import RegistrarBitacoras from "./view/RegistrarBitacoras";
import RegistrarCentros from "./view/RegistrarCentros";
import RegistrarContratos from "./view/RegistrarContratos";
import RegistrarEnte from "./view/RegistrarEnteConformador";
import RegistrarEnteVsJefe from "./view/RegistrarEnteVsJefe";
import RegistrarEProductiva from "./view/RegistrarEProductiva";
import RegistrarEProductivaMasivo from "./view/RegistrarEProductivaMasivo";
import RegistrarFirmaAcudiente from "./view/RegistrarFirmaAcudiente";
import RegistrarFirmaAprendiz from "./view/RegistrarFirmaAprendiz";
import RegistrarFirmaInstructor from "./view/RegistrarFirmaInstructor";
import RegistrarFirmaJefe from "./view/RegistrarFirmaJefe";
import RegistrarGrupoInstructores from "./view/RegistrarGrupoInstructores";
import RegistrarGrupos from "./view/RegistrarGrupos";
import RegistrarGuia from "./view/RegisrtarGuiasdeAprendizaje";
import RegistrarInformeContractual from "./view/RegistrarInformeContractual";
import RegisatrarInstructores from "./view/RegistrarInstructores";
import RegistrarJefes from "./view/RegistrarJefes";
import RegistrarMatriculas from "./view/RegistrarMatriculas";
import RegistrarModulo from "./view/RegistrarModulo";
import RegistrarObligaciones from "./view/RegistrarObligaciones";
import RegistrarProgramas from "./view/RegistrarProgramas";
import RegistrarRegionales from "./view/RegistrarRegionales";
import RegistrarResoluciones from "./view/RegistrarResoluciones";
import RegistrarRol from "./view/RegistrarRol";
import RegistrarSegPracticaAprendiz from "./view/RegistrarSegPracticaAprendiz";
import RegistrarSegPracticaMasivo from "./view/RegistrarSegPracticaMasivo";
import RegistrarTarjetaAprendiz from "./view/RegistrarTarjetaAprendiz";
import RegistarTestKolb from "./view/RegistarTestKolb";
import Reportes from "./view/ReportesDashboard";
import ResgistrarAprendices from "./view/RegistrarAprendices";
import LandingPage from "./pages/LandingPage"
import ListarProgramaInstructores from "./view/ListarProgramaInstructores";
import RegistrarProgramaInstructores from "./view/RegistrarProgramaInstructores";
import RegistrarLegalizcionAgendaViatico from "./view/RegistrarLegalizcionAgendaViatico";
import ListarLegalizacionViaticos from "./view/ListarLegalizacionViaticos";
// Cobros y suscripciones - Listados
import ListarPlanes from "./view/ListarPlanes";
import ListarSuscripciones from "./view/ListarSuscripciones";
import ListarPagos from "./view/ListarPagos";
import ListarSolicitudesRenovacion from "./view/ListarSolicitudesRenovacion";
import ListarHistorialSuscripciones from "./view/ListarHistorialSuscripciones";
import ListarConfiguracionCobros from "./view/ListarConfiguracionCobros";

// Cobros y suscripciones - Formularios
import RegistrarPlanes from "./view/RegistrarPlanes";
import RegistrarSuscripciones from "./view/RegistrarSuscripciones";
import RegistrarPagos from "./view/RegistrarPagos";
import RegistrarSolicitudesRenovacion from "./view/RegistrarSolicitudesRenovacion";
import RegistrarConfiguracionCobros from "./view/RegistrarConfiguracionCobros";
import RegistrarHistorialSuscripciones from "./view/RegistrarHistorialSuscripciones";

// Mi suscripcion
import MiSuscripcion from "./components/MiSuscripcion";

// Auditoría
import AuditoriaListarTipoDocumento from "./view/Auditoria_ListarTipoDocumento";
import AuditoriaRegistrarTipoDocumento from "./view/Auditoria_RegistrarTipoDocumento";

import AuditoriaListarCriterio from "./view/Auditoria_ListarCriterio";
import AuditoriaRegistrarCriterio from "./view/Auditoria_RegistrarCriterio";

import AuditoriaListarAsignacion from "./view/Auditoria_ListarAsignacion";
import AuditoriaRegistrarAsignacion from "./view/Auditoria_RegistrarAsignacion";

import AuditoriaListarDocumento from "./view/Auditoria_ListarDocumento";
import AuditoriaRevisarDocumento from "./view/Auditoria_RevisarDocumento";

import AuditoriaListarRevision from "./view/Auditoria_ListarRevision";






function App() {
  return (
    <div className="App">
      <Routes>
        {/* Público */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />

        {/* Protegidas */}
        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout />}>
            {/* Principal */}
            <Route path="/dashboard" element={<Navigate to="/inicio" replace />} />
            <Route path="/inicio" element={<Home />} />

            {/* Actividad */}
            <Route path="/actividad/asistencia/:id" element={<ListarActividad />} />
            <Route path="/actividad/editar/:id" element={<RegistrarActividad />} />
            <Route path="/actividad/nuevo/:id" element={<RegistrarActividad />} />
            <Route path="/asistencia/:id" element={<RegistrarAsistencia />} />

            {/* Aprendiz */}
            <Route path="/aprendiz" element={<ListarAprendices />} />
            <Route path="/aprendiz/:id" element={<DetalleAprendiz />} />
            <Route path="/aprendiz/edit/:id" element={<ResgistrarAprendices />} />
            <Route path="/aprendiz/nuevo" element={<ResgistrarAprendices />} />
            <Route path="/aprendiz/registrarfirma/:id" element={<RegistrarFirmaAprendiz />} />
            <Route path="/aprendiz/registrarfirma/:idAprendiz/:idAcudiente" element={<RegistrarFirmaAcudiente />} />
            <Route path="/aprendiz/testkolb/editar/:testid" element={<RegistarTestKolb />} />
            <Route path="/aprendiz/testkolb/registrar/:id" element={<RegistarTestKolb />} />

            {/* Configuraciones */}
            <Route path="/configuraciones/asignarmodulos" element={<AsignacionModulos />} />
            <Route path="/configuraciones/notificaciones" element={<Notificaciones />} />

            {/* Ente conformador */}
            <Route path="/enteconformador/asociar/:id" element={<ListarEnteVsJefe />} />
            <Route path="/enteconformador/asociar/editar/:idasociado" element={<RegistrarEnteVsJefe />} />
            <Route path="/enteconformador/asociar/nuevo/:id" element={<RegistrarEnteVsJefe />} />
            <Route path="/enteconformador/ente" element={<ListarEnte />} />
            <Route path="/enteconformador/ente/editar/:id" element={<RegistrarEnte />} />
            <Route path="/enteconformador/ente/nuevo" element={<RegistrarEnte />} />
            <Route path="/enteconformador/jefes" element={<ListarJefes />} />
            <Route path="/enteconformador/jefes/edit/:id" element={<RegistrarJefes />} />
            <Route path="/enteconformador/jefes/nuevo" element={<RegistrarJefes />} />
            <Route path="/enteconformador/jefes/registrarfirma/:id" element={<RegistrarFirmaJefe />} />
            <Route path="/enteconformador/resoluciones/:id" element={<ListarResoluciones />} />
            <Route path="/enteconformador/resoluciones/editar/:idResolucion" element={<RegistrarResoluciones />} />
            <Route path="/enteconformador/resoluciones/registrar/:idEnte" element={<RegistrarResoluciones />} />

            {/* Etapa productiva */}
            <Route path="/etapaproductiva/bitacoras/:etapaId/:aprendizId/:matriculaId" element={<RegistrarBitacoras />} />
            <Route path="/etapaproductiva/bitacoras/registromasivo/:matriculaId" element={<RegistrarBitacoras />} />
            <Route path="/etapaproductiva/editar/:epracticaId" element={<RegistrarEProductiva />} />
            <Route path="/etapaproductiva/listareproductiva" element={<ListarEProductiva />} />
            <Route path="/etapaproductiva/nuevo" element={<RegistrarEProductiva />} />
            <Route path="/etapaproductiva/registro/:aprendizId/:matriculaId" element={<RegistrarEProductiva />} />
            <Route path="/etapaproductiva/registromasivo/:matriculaId" element={<RegistrarEProductivaMasivo />} />
            <Route path="/etapaproductiva/seguimiento/:etapaId/:aprendizId/:matriculaId" element={<RegistrarSegPracticaAprendiz />} />
            <Route path="/etapaproductiva/seguimiento/registromasivo/:matriculaId" element={<RegistrarSegPracticaMasivo />} />

            {/* Grupo instructores */}
            <Route path="/grupoinstructores" element={<ListarGrupoInstructores />} />
            <Route path="/grupoinstructores/editar/:id" element={<RegistrarGrupoInstructores />} />
            <Route path="/grupoinstructores/registrar" element={<RegistrarGrupoInstructores />} />

            {/* Programa instructores */}
            <Route path="/programainstructores" element={<ListarProgramaInstructores />} />
            <Route path="/programainstructores/editar/:id" element={<RegistrarProgramaInstructores />} />
            <Route path="/programainstructores/registrar" element={<RegistrarProgramaInstructores />} />


            {/* Institucional */}
            <Route path="/institucional/actas/:id" element={<ListarActas />} />
            <Route path="/institucional/actas/editar/:id" element={<RegistrarActas />} />
            <Route path="/institucional/actas/nuevo/:fichaGrupo" element={<RegistrarActas />} />
            <Route path="/institucional/centro" element={<ListarCentros />} />
            <Route path="/institucional/centro/edit/:id" element={<RegistrarCentros />} />
            <Route path="/institucional/centro/nuevo" element={<RegistrarCentros />} />
            <Route path="/institucional/grupos" element={<ListarGrupos />} />
            <Route path="/institucional/grupos/edit/:id" element={<RegistrarGrupos />} />
            <Route path="/institucional/grupos/nuevo" element={<RegistrarGrupos />} />
            <Route path="/institucional/guias/editar/:guiaId" element={<RegistrarGuia />} />
            <Route path="/institucional/guias/listarguias/:codPrograma" element={<ListarGuias />} />
            <Route path="/institucional/guias/nuevo/:codPrograma" element={<RegistrarGuia />} />
            <Route path="/institucional/programas" element={<ListarProgramas />} />
            <Route path="/institucional/programas/edit/:id" element={<RegistrarProgramas />} />
            <Route path="/institucional/programas/nuevo" element={<RegistrarProgramas />} />
            <Route path="/institucional/regional" element={<ListarRegionales />} />
            <Route path="/institucional/regional/edit/:id" element={<RegistrarRegionales />} />
            <Route path="/institucional/regional/nuevo" element={<RegistrarRegionales />} />

            {/* Instructor */}
            <Route path="/instructor" element={<ListarInstructores />} />
            <Route path="/instructor/agendas/:id" element={<ListarAgendasViaticos />} />
            <Route path="/instructor/agendas/editar/:id" element={<RegistrarAgendasViaticos />} />
            <Route path="/instructor/agendas/nuevo/:id" element={<RegistrarAgendasViaticos />} />
            <Route path="/instructor/edit/:id" element={<RegisatrarInstructores />} />
            <Route path="/instructor/informecontractual/:id" element={<RegistrarInformeContractual />} />
            <Route path="/instructor/informecontractual/editar/:informeId" element={<RegistrarInformeContractual />} />
            <Route path="/instructor/informecontractual/listar/:id" element={<ListarInformesContractuales />} />
            <Route path="/instructor/listarcontratos/:id" element={<ListarContratos />} />
            <Route path="/instructor/nuevo" element={<RegisatrarInstructores />} />
            <Route path="/instructor/obligaciones/:id" element={<ListarObligaciones />} />
            <Route path="/instructor/obligaciones/editar/:id" element={<RegistrarObligaciones />} />
            <Route path="/instructor/obligaciones/nuevo/:id" element={<RegistrarObligaciones />} />
            <Route path="/instructor/registrarcontratos/:id" element={<RegistrarContratos />} />
            <Route path="/instructor/registrarcontratos/editar/:idcontrato" element={<RegistrarContratos />} />
            <Route path="/instructor/registrarfirma/:id" element={<RegistrarFirmaInstructor />} />
            <Route path="/instructor/legalizacionviaticos/nuevo/:id" element={<RegistrarLegalizcionAgendaViatico />} />
            <Route path="/instructor/legalizacionviaticos/update/:id" element={<RegistrarLegalizcionAgendaViatico />} />
            <Route path="/instructor/legalizacionviaticos/listar/:id" element={<ListarLegalizacionViaticos />} />

            {/* Matrícula */}
            <Route path="/matricula/editar/:id" element={<RegistrarMatriculas />} />
            <Route path="/matricula/listarmatriculados/:id" element={<ListarMatriculados />} />
            <Route path="/matricula/listarmatriculas" element={<ListarMatriculas />} />
            <Route path="/matricula/registrar" element={<RegistrarMatriculas />} />

            {/* Perfil y reportes */}
            <Route path="/perfil" element={<MiPerfil />} />
            <Route path="/perfil/editar/:id" element={<MiPerfilEditar />} />
            <Route path="/reportes" element={<Reportes />} />

            {/* Seguridad */}
            <Route path="/seguridad/modulos/editar/:id" element={<RegistrarModulo />} />
            <Route path="/seguridad/modulos/registrar" element={<RegistrarModulo />} />
            <Route path="/seguridad/roles/editar/:id" element={<RegistrarRol />} />
            <Route path="/seguridad/roles/registrar" element={<RegistrarRol />} />

            {/* Tarjeta aprendiz */}
            <Route path="/tarjeta/listartarjetaaprendiz" element={<ListarTarjetaAprendiz />} />
            <Route path="/tarjeta/nuevo" element={<RegistrarTarjetaAprendiz />} />
            <Route path="/tarjeta/editar/:id" element={<RegistrarTarjetaAprendiz />} />

            {/* ========================== COBROS Y SUSCRIPCIONES =========== */}

            {/* Planes */}
            <Route path="/cobros/planes" element={<ListarPlanes />} />
            <Route path="/cobros/planes/nuevo" element={<RegistrarPlanes />} />
            <Route path="/cobros/planes/edit/:id" element={<RegistrarPlanes />} />
            
            {/* Suscripciones */}
            <Route path="/cobros/suscripciones" element={<ListarSuscripciones />} />
            <Route path="/cobros/suscripciones/nueva" element={<RegistrarSuscripciones />} />
            <Route path="/cobros/suscripciones/edit/:id" element={<RegistrarSuscripciones />} />

            {/* Pagos */}
            <Route path="/cobros/pagos" element={<ListarPagos />} />
            <Route path="/cobros/pagos/nuevo" element={<RegistrarPagos />} />
            <Route path="/cobros/pagos/edit/:id" element={<RegistrarPagos />} />

            {/* Solicitudes de renovación */}
            <Route path="/cobros/renovaciones" element={<ListarSolicitudesRenovacion />} />
            <Route path="/cobros/renovaciones/nueva" element={<RegistrarSolicitudesRenovacion />} />
            <Route path="/cobros/renovaciones/edit/:id" element={<RegistrarSolicitudesRenovacion />} />

            {/* Historial */}
            <Route path="/cobros/historial" element={<ListarHistorialSuscripciones />} />
            <Route path="/cobros/historial/nuevo" element={<RegistrarHistorialSuscripciones />} />

            {/* Configuración */}
            <Route path="/cobros/configuracion" element={<ListarConfiguracionCobros />} />
            <Route path="/cobros/configuracion/nueva" element={<RegistrarConfiguracionCobros />} />
            <Route path="/cobros/configuracion/edit/:id" element={<RegistrarConfiguracionCobros />} />
            
            {/* Mi Suscripcion */}
            <Route path="/mi-suscripcion" element={<MiSuscripcion />} />

            {/* ========================== AUDITORÍA ========================== */}

            {/* Tipos de documento */}
            <Route path="/auditoria/tipo-documento" element={<AuditoriaListarTipoDocumento />} />
            <Route path="/auditoria/tipo-documento/nuevo" element={<AuditoriaRegistrarTipoDocumento />} />
            <Route path="/auditoria/tipo-documento/editar/:id" element={<AuditoriaRegistrarTipoDocumento />} />

            {/* Criterios */}
            <Route path="/auditoria/criterio" element={<AuditoriaListarCriterio />} />
            <Route path="/auditoria/criterio/nuevo" element={<AuditoriaRegistrarCriterio />} />
            <Route path="/auditoria/criterio/editar/:id" element={<AuditoriaRegistrarCriterio />} />

            {/* Asignaciones auditor - instructor */}
            <Route path="/auditoria/asignacion" element={<AuditoriaListarAsignacion />} />
            <Route path="/auditoria/asignacion/nueva" element={<AuditoriaRegistrarAsignacion />} />
            <Route path="/auditoria/asignacion/editar/:id" element={<AuditoriaRegistrarAsignacion />} />

            {/* Panel documental */}
            <Route path="/auditoria/documento" element={<AuditoriaListarDocumento />} />

            {/* Revisión documental */}
            <Route path="/auditoria/documento/revisar/:id" element={<AuditoriaRevisarDocumento />} />

            {/* Historial de revisiones */}
            <Route path="/auditoria/revision" element={<AuditoriaListarRevision />} />

          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;